import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  OnChainBidInfoIconColorMode,
  OnChainBidInfoIconComponent,
} from '@/components/on-chain-bid-info-icon/on-chain-bid-info-icon.component';
import { showOnChainBidContractTooltip } from '@/utils/native-market-bid-labels';

/** On-chain bid copy plus optional Material (i) tooltip icon (V1 only). */
@Component({
  selector: 'app-on-chain-bid-label',
  standalone: true,
  imports: [CommonModule, OnChainBidInfoIconComponent],
  template: `
    <span class="on-chain-bid-label">
      <span class="on-chain-bid-label__text"><ng-content></ng-content></span>
      <app-on-chain-bid-info-icon
        *ngIf="showTooltip"
        [iconSize]="iconSize"
        [colorMode]="colorMode" />
    </span>
  `,
  styles: [
    `
      .on-chain-bid-label {
        display: inline-flex;
        align-items: center;
        gap: 0.35rem;
      }

      .on-chain-bid-label__text {
        display: inline;
      }
    `,
  ],
})
export class OnChainBidLabelComponent {
  @Input() showTooltip = showOnChainBidContractTooltip;
  @Input() iconSize: 14 | 16 = 16;
  @Input() colorMode: OnChainBidInfoIconColorMode = 'surface';
}
